import { getRequest, patchRequest } from '@helpers/api';

import type { GetUser, UpdateUserApi } from './types';

/**
 * Request user data
 */
export const getUser = (
  /** ID of user to retrieve details for */
  id: string
): Promise<GetUser> => getRequest(`auth/user/${id}/`);

/**
 * Update user data
 */
export const patchUser = (
  /** ID of user to update */
  id: string,
  /** User data to update */
  payload: UpdateUserApi
): Promise<GetUser> => patchRequest(`auth/user/${id}/`, payload);
